module.exports = __webpack_public_path__ + "img/dmv3.20eb16b9.webp";